module.exports = __webpack_public_path__ + "img/Weapon_184.06786aef.png";